import { Outlet } from 'react-router';
import SWRConfig from './SWRConfig/SWRConfig';
import { DownloadReportStatusContext } from './UseDownloadReportStatusContext';
import useDownloadReportStatusContextValue from './UseDownloadReportStatusContextValue';
import { UserProvider } from './UserContext';
import { UserSignupNavigationContext } from './UserSignupNavigationContext';
import useUserSignupNavigationContextValue from './UseUserSignupNavigationContextValue';
import NotificationSystem from '@/Components/NotificationSystem/NotificationSystem';
import StripeInitialization from '@/Initialization/StripeInitialization';

function RecruiterApplicationContextProvider() {
    const userSignupNavigationContextValue = useUserSignupNavigationContextValue();
    const downloadReportStatusContextValue = useDownloadReportStatusContextValue();

    return (
        <UserProvider>
            <StripeInitialization>
                <NotificationSystem>
                    <SWRConfig>
                        <UserSignupNavigationContext.Provider value={userSignupNavigationContextValue}>
                            <DownloadReportStatusContext.Provider value={downloadReportStatusContextValue}>
                                <Outlet />
                            </DownloadReportStatusContext.Provider>
                        </UserSignupNavigationContext.Provider>
                    </SWRConfig>
                </NotificationSystem>
            </StripeInitialization>
        </UserProvider>
    );
}

export default RecruiterApplicationContextProvider;
